import { useContext } from "react";
import { PusherContext } from "components/PusherProvider";

export const usePusher = () => {
	const context = useContext(PusherContext);

	if (!context) {
		throw new Error("usePusher must be used within PusherProvider");
	}

	return context;
};
